import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';

import {BaseComponent, Message} from 'iui-iconectiv-lib';
import {RegionalUserAgreementService} from "./rua.service";
import {Regions} from "../shared/enum";
import {AccountRua, BaseRua} from "../shared/model";
import {RegisterService} from "../register/register.service";

@Component({
  selector: 'regional-user-agreement',
  templateUrl: './rua.component.html',
  styleUrls: ['./rua.component.scss']
})
export class RegionalUserAgreementComponent extends BaseComponent {
  @Input() ruaList: BaseRua[];
  @Output() ruaListChange: EventEmitter<BaseRua[]> = new EventEmitter<BaseRua[]>();
  @ViewChild('ruaFileInput') ruaFileInput

  showRuaDialog: boolean = false;
  headers;
  attachmentUrl: string;

  regions: { id: string, label: string }[] = Regions.regions;
  selectedRegions: string[] = [];
  ruaMap;

  constructor(private ruaService: RegionalUserAgreementService,
              private registerService: RegisterService,) {
    super();

    this.ruaService.getAttachmentDownloadUrl().subscribe(url => {
      this.attachmentUrl = url;
    });

    this.headers = [
      {header: 'Region', width: '15'},
      {header: 'Contact Number', width: '22'},
      {header: 'Effective Date', width: '30'},
      {header: 'Attachment', width: '18'}
    ];

    this.ruaMap = this.getEmptyRuaMap();
  }

  processUploadedRuaFile(region: string, files) {
    this.ruaMap[region].ruaUserFileName = files[0]['name'];
    this.ruaMap[region].ruaUserFileSize = files[0]['size'];
    this.ruaMap[region].ruaUserFileType = files[0]['type'];

    this.ruaMap[region].isValidFileSize = (0 < this.ruaMap[region].ruaUserFileSize && this.ruaMap[region].ruaUserFileSize < 500000)
    this.ruaMap[region].isValidFileType = ('application/pdf' === this.ruaMap[region].ruaUserFileType)

    const reader = new FileReader();
    reader.onload = () => {
      const dataUri = reader.result as string;
      const comma = dataUri.indexOf(',');

      var rua: AccountRua = this.ruaMap[region];
      rua.attachmentId = '';
      rua.attachmemtContent = dataUri.substring(comma + 1);

      const json = `{"fileName" : "${rua.ruaParcelFileName}","contentType" : "application/pdf","content" : "${rua.attachmemtContent}"}`;
      this.ruaService.saveAccountRua(json).subscribe(
        res => {
          this.log.debug(`data=${JSON.stringify(res).substr(0, 1000)}`);

          if (res['status'] === 'fail') {
            // prepare error message
            const message: any = res['messages'][0];
            const errorMessage = message['code'] + ' - ' + message['message'];
            this.displayErrorMessage(errorMessage);
          } else {
            rua.attachmentId = res['attachmentId'];
            rua.attachmemtContent = '';
          }
        },
        error => this.processHttpError(error)
      );
    };

    reader.readAsDataURL(files[0]);
  }

  save() {

    var updatedRuaList: BaseRua[] = [];

    for (const region of this.selectedRegions) {
      var rua = this.ruaMap[region];

      if (rua.attachmentId) {
        const updatedRua = new BaseRua();
        updatedRua.attachmentId = rua.attachmentId;
        updatedRua.contractNumber = rua.contractNumber;
        updatedRua.expirationDate = rua.expirationDate;
        updatedRua.region = rua.region;
        updatedRuaList.push(updatedRua);
      }
    }

    this.ruaListChange.emit(updatedRuaList);
  }

  show() {
    this.cleanup();
    this.showRuaDialog = true;
  }

  hide() {
    this.showRuaDialog = false;

  }

  cleanup() {
    this.ruaMap = this.getEmptyRuaMap();
    this.ruaFileInput.nativeElement.value = '';
    this.selectedRegions = this.ruaList.map(rua => rua.region);
    this.ruaList.forEach(r => {
      var rua: AccountRua = this.ruaMap[r.region];
      rua.region = r.region;
      rua.attachmentId = r.attachmentId;
      rua.contractNumber = r.contractNumber;
      rua.expirationDate = r.expirationDate;
    });
  }

  getEmptyRuaMap() {
    return this.regions.reduce((map, region) => {
      map[region.label] = new AccountRua(region.label);
      return map
    }, {});
  }

  isRegionSelected(region: string): boolean {
    return this.selectedRegions.indexOf(region,0) > -1;
  }

  btnChooseRuaFile(region: string): string {
    return this.isRegionSelected(region) ? 'btn btn-default' : 'btn btn-disabled';
  }


  /**
   * call base class's displayErrorMessage() for error.
   */
  displayError() {
    this.displayErrorMessage(
      new Message('Error', 'The system was unsuccessful in processing your request. Please try again, or contact Customer Support for assistance.')
    );
  }

}
